import React from 'react';
import { Icon } from './Icon.js';
export const IconStar = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m10.763,3.038l1.779,3.604,3.979.578c.698.101.977.959.472,1.452l-2.879,2.806.68,3.962c.119.695-.61,1.225-1.235.897l-3.558-1.87-3.558,1.87c-.624.328-1.354-.202-1.235-.897l.68-3.962-2.879-2.806c-.505-.492-.226-1.35.472-1.452l3.979-.578,1.779-3.604c.312-.633,1.214-.633,1.526,0Z", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" })));
};
//# sourceMappingURL=IconStar.js.map